import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { Row, Col, Card, CardHeader, Button, Input } from "reactstrap"
import { saveCourierRecurringDeliveryDiscountConfiguration } from "../../apollo/server"
import { useMutation, gql } from "@apollo/client"
import { Alert } from "reactstrap/lib"

interface IProps {
  rate: number
}

// 何でも配送(お使い便)の「定期」配達料割引率(%)。プラットフォーム(管理画面)で設定する。
// 店舗が無い何でも便の配達料割引はプラットフォーム領分のため、ここで一括設定する。
const CourierRecurringDiscount: React.FC<IProps> = props => {
  const { t } = useTranslation()
  const [rate, setRate] = useState<string>(String(props.rate ?? 0))
  const [successMessage, setSuccessMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")

  const [save, { loading, error }] = useMutation(gql`${saveCourierRecurringDeliveryDiscountConfiguration}`, {
    onCompleted: () => setSuccessMessage(t("Saved") || "保存しました"),
    onError: e => {
      setErrorMessage(t("ErrorMessage"))
      console.log(e)
    },
  })
  if (error) return <p>{t("Error")}</p>

  function submit(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault()
    if (loading) return
    const n = Math.min(100, Math.max(0, Number(rate) || 0))
    save({ variables: { rate: n } })
  }

  const onDismiss = () => {
    setSuccessMessage("")
    setErrorMessage("")
  }

  return (
    <Row className="mt-3">
      <div className="col">
        <Card className="shadow">
          <CardHeader className="border-0">
            <h3 className="mb-0">{t("CourierRecurringDeliveryDiscountRate")}</h3>
            <small className="text-muted">{t("CourierRecurringDiscountHint")}</small>
          </CardHeader>

          <Row className="ml-3 mr-3" style={{ display: "flex", alignItems: "center" }}>
            <Col md="10">
              <Input
                type="number"
                min={0}
                max={100}
                value={rate}
                onChange={e => setRate(e.target.value)}
                className="form-control-alternative"
                style={{ maxWidth: 200 }}
              />
            </Col>
            <Col md="2">
              <Button className="btn-block mb-2" type="button" color="primary" onClick={submit} size="lg">
                {loading ? t("Saving") : t("Save")}
              </Button>
            </Col>
          </Row>
          <Row className="mx-3" style={{ display: "flex", justifyContent: "flex-end" }}>
            <Col md="6">
              <Alert color="success" isOpen={!!successMessage} toggle={onDismiss}>
                <span className="alert-inner--text" style={{ whiteSpace: "pre-wrap" }}>
                  <strong>{t("Success")}! </strong>
                  {successMessage}
                </span>
              </Alert>
              <Alert color="danger" isOpen={!!errorMessage} toggle={onDismiss}>
                <span className="alert-inner--text">
                  <strong>{t("Danger")}!</strong> {errorMessage}
                </span>
              </Alert>
            </Col>
          </Row>
        </Card>
      </div>
    </Row>
  )
}
export default CourierRecurringDiscount
